import { inject, Injectable } from "@angular/core";
import { CreateIncidenceRequest, IncidenceRatingPreviewDto } from "@dtos/quality/incidents.dto";
import { ApiService, EndPoints } from "@services/index";
import { IncidencesListRequest } from "@dtos/quality/incident.item";
import { AdjustmentsListRequest, CreateAdjustmentDto } from "@dtos/quality/adjustment.item";
import { BlackListDriverItem } from "@dtos/quality/blackList";
import { IncidentsMetricDto } from "@dtos/quality/incidents.metric.dto";
import { AdjustmentActionType, AdjustmentReason, AdjustmentSubType } from "@enums/adjustment";
import { Severity } from "@enums/additional.enum";

@Injectable({ providedIn: 'root' })
export class QualityProvider {
    private readonly api = inject(ApiService);


    async createIncidence(data: CreateIncidenceRequest): Promise<any | null> {
        try {
            return await this.api.post<any>({
                url: EndPoints.createIncidence,
                body: data
            });
        } catch (error) {
            console.error('Error al crear incidencia:', error);
            return null;
        }
    }
    async updateIncidence(incidentId: number, data: any): Promise<any | null> {
        try {
            return await this.api.patch<any>({
                url: EndPoints.updateIncidence.replace("{incidenceId}", incidentId.toString()),
                body: data
            });
        } catch (error) {
            console.error('Error al crear incidencia:', error);
            return null;
        }
    }
    async deleteIncidence(incidenceId: number): Promise<any | null> {
        try {
            return await this.api.delete<any>({
                url: EndPoints.deleteIncidence.replace("{incidenceId}", incidenceId.toString())
            });
        } catch (error) {
            console.error('Error al borrar incidencia:', error);
            return null;
        }
    }
    async addCommentIncidence(incidenceId: number, comment: string): Promise<any | null> {
        try {
            return await this.api.post<any>({
                url: EndPoints.addCommentIncidence.replace("{incidenceId}", incidenceId.toString()),
                body: {comment}
            });
        } catch (error) {
            console.error('Error al crear incidencia:', error);
            return null;
        }
    }
    
    async getIncidents(request?: IncidencesListRequest): Promise<any[] | null> {
        try {
            let url = EndPoints.getTransportIncidents.toString();

            return await this.api.get<any[]>({ url, queryParams: request });
        } catch (error) {
            console.error('Error al obtener transporte:', error);
            return null;
        }
    }
    async exportIncidents(request?: IncidencesListRequest): Promise<any[] | null> {
        try {
            let url = EndPoints.exportIncidents.toString();

            return await this.api.get<any>({ url, queryParams: request });
        } catch (error) {
            console.error('Error al obtener transporte:', error);
            return null;
        }
    }
    async getAdjustments(petition?: AdjustmentsListRequest): Promise<any[] | null> {
        try {
            let url = EndPoints.getAdjustments.toString();
            return await this.api.get<any[]>({ url, queryParams: petition });
        } catch (error) {
            console.error('Error al obtener transporte:', error);
            return null;
        }
    }
    async getDriversTransport(transportId: number): Promise<any[] | null> {
        try {
            let url = EndPoints.getDriversTransport.replace("{transportId}", transportId.toString());
            return await this.api.get<any[]>({ url });
        } catch (error) {
            console.error('Error al obtener transporte:', error);
            return null;
        }
    }
    async getIncidentById(id: number): Promise<any | null> {
        try {
            let url = EndPoints.getIncidence.replace("{incidenceId}", id.toString());
            return await this.api.get<any>({ url });
        } catch (error) {
            console.error('Error al obtener transporte:', error);
            return null;
        }
    }
    async getAdjustmentById(id: number): Promise<any | null> {
        try {
            let url = EndPoints.getAdjustment.replace("{adjustmentId}", id.toString());
            return await this.api.get<any>({ url });
        } catch (error) {
            console.error('Error al obtener transporte:', error);
            return null;
        }
    }
    async getBlackListByDriver(driverId: number): Promise<BlackListDriverItem[] | null> {
        try {
            let url = EndPoints.driverBlackList.replace('{driver_id}', driverId.toString()).toString();
            return await this.api.get<BlackListDriverItem[]>({ url });
        } catch (error) {
            console.error('Error al obtener transporte:', error);
            return null;
        }
    }
    async getIncidentsMetrics(incidenceId: number): Promise<IncidentsMetricDto | null> {
        try {
            let url = EndPoints.getIncidenceMetrics.replace('{incidenceId}', incidenceId.toString()).toString();
            return await this.api.get<IncidentsMetricDto>({ url });
        } catch (error) {
            console.error('Error al obtener transporte:', error);
            return null;
        }
    }
    async calculateAmmount(reason: AdjustmentReason, reasonSubType: AdjustmentSubType, transportId?: number, quantity?: number): Promise<AdjustmentActionType> {
        try {
            let url = EndPoints.calculateAmmount.replace("{reason}", reason.toString()).replace("{reasonSubType}", reasonSubType.toString());
            if (transportId) {
                url = url.replace("{transportId}", transportId.toString());
            } else {
                url = url.replace("&transport_id={transportId}", "");
            }
            if(quantity)
                url = url.replace("{quantity}", quantity.toString()).toString();
            else
                url = url.replace("&quantity={quantity}", "").toString();
            return await this.api.get<AdjustmentActionType>({ url });
        } catch (error) {
            console.error('Error al obtener transporte:', error);
            throw error;
        }
    }
    async getRatingDriveer(incidence_id: number, subtype:AdjustmentSubType,  severity: Severity,quantity?: number): Promise<IncidenceRatingPreviewDto | null> {
        try {
            return await this.api.post  <IncidenceRatingPreviewDto>({ url: EndPoints.getPrevieweRating, body: {incidence_id, subtype, severity, quantity} });
        } catch (error) {
            console.error('Error al obtener transporte:', error);
            return null;
        }
    }
    async saveAdjustment(adjustment: Partial<CreateAdjustmentDto>, id?: number): Promise<any | null> {
        try {
            if(id){
                return await this.api.patch<any>({
                    url: EndPoints.updateAdjustment.replace("{adjustmentId}", id.toString()),
                    body: adjustment
                });
            }else{
                return await this.api.post<any>({
                    url: EndPoints.createAdjustment,
                    body: adjustment
                });
            }
        } catch (error) {
            console.error('Error al guardar ajuste:', error);
            return null;
        }
    }
    async deleteAdjustment(id: number): Promise<any | null> {
        try {
            return await this.api.delete<any>({
                url: EndPoints.deleteAdjustment.replace("{adjustmentId}", id.toString())
            });
        } catch (error) {
            console.error('Error al eliminar ajuste:', error);
            throw error;
        }

    }
}
